import React, {useState} from 'react'
import DataTable from '../../Common/DataTable';
import {formataMoeda} from '../../Helpers/money';
import {formata} from '../../Helpers/date';
import useFetchData from '../../crud/useFetchData';
import {proto,url} from '../../Helpers/api';
import {get,sortBy} from 'lodash-es';
import Typography from '@material-ui/core/Typography';

var PG_SIZE = 5

export default function Lancamentos_ (props) {
  const { empresaId, ano, mes, conta } = props;
  let codcta = conta && conta.CODI_CTA
  if (!codcta) return null;
  let Url = `${proto}://${url}/teste/lancto/${empresaId}/${ano}/${mes}`
  const f = useFetchData(Url, { p: 1, params: { codcta } })
  let dados = [];
  if (get(f,"isFinished")) {
    dados = get(f,"data", []);
  }
  if (get(f,"isLoading")) return <div>Carregando dados...</div>
  if (get(f,"error")) return <div>Erro ao carregar dados!</div>
  return (
    <Lancamentos 
      url={Url}
      dados={dados}
      f={f}
      conta={conta}
    />
  )
}

function Lancamentos(props) {
  const { dados, conta, url, f } = props;
  const { hasMore, next } = f;
  // if (!dados.length) return null;
  // let len = dados.length
  // let qtdeMax = pagina * len
  // let more = len === qtdeMax
  return (
    <div style={{
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      paddingTop: "10px",
      paddingBottom: "10px",
    }}>
      <Typography variant="display2">Lançamentos</Typography>
      <Typography variant="display1">{conta.NOME_CTA}</Typography>
      <div style={{ width: "95%" }}>
        <DataTable 
          cols={["80px", "1fr", "auto", "30px"]}
          // comps={{
          //   Codigo: Teste({value:selecteds, onChange:setSelecteds })
          // }}
          title={["Data", "Histórico", "Valor", "Tipo"]}
          data={dados}
          dataIdx={["DataLan", "Historico", "Valor", "Tipo"]}
          modif={{
            DataLan: formata,
            Valor: formataMoeda
          }}
          more={hasMore && {
            hasMore,
            next
          }}
          // more={hasMore && {
          //   PG_SIZE,
          //   update: setDados,
          //   url
          // }}
        />
      </div>
    </div>
  )
}
